import {BasePathUrl} from "../appsettings";

/** Домашний маршрут SPA (HashRouter). */
export const getSpaHomeUrl = (): string =>
  new URL(`${BasePathUrl}/#/users`, globalThis.location.origin).toString();

/**
 * Страница логина SPA (обычный logout / ReturnUrl).
 * Не целевой URL impersonate: без access к Auth туда ведёт PrivateRoute.
 */
export const getSpaLoginPath = (): string => `${BasePathUrl}/#/login`;

export const getSpaLoginUrl = (): string =>
  new URL(getSpaLoginPath(), globalThis.location.origin).toString();

/**
 * Нормализует redirect из ImpersonateResult для SPA под BasePathUrl.
 * Сервер может вернуть "/" — это корень домена, а не модуль.
 */
export const resolveImpersonateRedirect = (redirect?: string | null): string => {
  if (!redirect || redirect === "/") {
    const homeUrl = getSpaHomeUrl();
    // eslint-disable-next-line no-console
    console.debug("Redirect is empty or /, returning spa home url", homeUrl);
    return homeUrl;
  }

  if (redirect.startsWith("#")) {
    // eslint-disable-next-line no-console
    console.debug("Redirect starts with #, returning url", redirect);
    return new URL(`${BasePathUrl}/${redirect}`, globalThis.location.origin).toString();
  }

  // eslint-disable-next-line no-console
  console.debug("Redirect is not empty, returning url", redirect);
  return new URL(redirect, globalThis.location.origin).toString();
};

/** ReturnUrl из hash (#/login?ReturnUrl=...) или из window.location.search. */
export const parseReturnUrl = (): string | null => {
  const hashQuery = globalThis.location.hash.includes("?")
    ? globalThis.location.hash.slice(globalThis.location.hash.indexOf("?"))
    : "";
  const fromHash = new URLSearchParams(hashQuery).get("ReturnUrl");
  if (fromHash) {
    return fromHash;
  }

  return new URLSearchParams(globalThis.location.search).get("ReturnUrl");
};
